import React from 'react';
import './section-label.scss';

type Props = {
  value: string,
};

const SectionLabel = ({ value } : Props): JSX.Element => {

  return (
    <div data-testid="SectionLabel" className="section-label-container ">
      <span className="section-label-container-value">
        {value}
      </span>
    </div>
  );
};

export default SectionLabel;
